import * as Sentry from "@sentry/react";
import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import createSentryMiddleware from "redux-sentry-middleware";

import {
  areaReducer,
  calendarReducer,
  learnerReducer,
  userReducer,
} from "./slices";

const customizedMiddleware = [
  ...getDefaultMiddleware({
    thunk: false,
    serializableCheck: false,
  }),
  // @ts-ignore
  createSentryMiddleware(Sentry),
];

const rootReducer = combineReducers({
  user: userReducer,
  calendar: calendarReducer,
  learner: learnerReducer,
  area: areaReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: customizedMiddleware,
  enhancers: [Sentry.createReduxEnhancer()],
});

export type RootState = ReturnType<typeof rootReducer>;
export type StoreDispatch = typeof store.dispatch;
